<div class="share-details-text">
  <strong>{{ share.object?.name }}</strong>
  <ng-container *ngIf="share.isOut"> &rarr; {{ share.sharerOrganization?.name }}</ng-container>
  <ng-container *ngIf="share.isIn"> &larr; {{ share.ownerOrganization?.name }}</ng-container>
</div>

